import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Checkbox,
  IconButton, Collapse, Box, Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatBRL } from '../../../UI';
import * as C from '../../../../theme/colors.constants';

function LinhaTitulo({
  titulo, colunas, selecionado, onSelecionar,
}) {
  const [aberta, setAberta] = useState(false);

  return (
    <>
      <TableRow hover selected={selecionado}>
        <TableCell padding="checkbox">
          <Checkbox checked={selecionado} onChange={onSelecionar} />
        </TableCell>
        {colunas.map(coluna => (
          <TableCell key={coluna.id} align={coluna.align}>
            {titulo[coluna.id]}
          </TableCell>
        ))}
        <TableCell align="center">
          <IconButton
            size="small"
            aria-label={aberta ? 'Recolher detalhes' : 'Expandir detalhes'}
            onClick={() => setAberta(atual => !atual)}
          >
            {aberta ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={colunas.length + 2} sx={{ py: 0, border: aberta ? undefined : 0 }}>
          <Collapse in={aberta} timeout="auto" unmountOnExit>
            <Box sx={{
              display: 'flex', justifyContent: 'space-between', gap: 2, py: 1.5, flexWrap: 'wrap',
            }}
            >
              <Typography variant="body2">
                <b>Protesto: </b>
                {formatBRL(titulo.valorProtesto)}
              </Typography>
              <Typography variant="body2">
                <b>Multa: </b>
                {formatBRL(titulo.valorMulta)}
              </Typography>
              <Typography variant="body2">
                <b>Juros: </b>
                {formatBRL(titulo.valorJuros)}
              </Typography>
              <Typography variant="body2">
                <b>Honorários: </b>
                {formatBRL(titulo.valorHonorarios)}
              </Typography>
              <Typography variant="body2">
                <b>Desconto: </b>
                {formatBRL(titulo.valorDesconto)}
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
LinhaTitulo.propTypes = {
  titulo: PropTypes.object.isRequired,
  colunas: PropTypes.array.isRequired,
  selecionado: PropTypes.bool.isRequired,
  onSelecionar: PropTypes.func.isRequired,
};

/**
 * Tabela de títulos do Passo 1 de Novo Acordo — port de `TableNovoAcordo.jsx`
 * real (MUI v4) para MUI v5. Ordenação via `TableSortLabel` nativo do MUI v5
 * (substitui `OrdenacaoColuna`/`TableHeader` customizados da tela real —
 * mesma UX, sem portar infraestrutura própria quando a stack alvo já resolve).
 */
export default function TableNovoAcordo({
  colunas, titulos, selectedIds, onToggleId, todosSelecionados, onToggleTodos, ordenacao, onClickColuna,
}) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox checked={todosSelecionados} onChange={onToggleTodos} />
          </TableCell>
          {colunas.map(coluna => (
            <TableCell key={coluna.id} align={coluna.align}>
              {coluna.sortable ? (
                <TableSortLabel
                  active={ordenacao.element === coluna.id}
                  direction={ordenacao.element === coluna.id ? ordenacao.order.toLowerCase() : 'asc'}
                  onClick={() => onClickColuna(coluna.id)}
                >
                  {coluna.label}
                </TableSortLabel>
              ) : coluna.label}
            </TableCell>
          ))}
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {titulos.map(titulo => (
          <LinhaTitulo
            key={titulo.idTitulo}
            titulo={titulo}
            colunas={colunas}
            selecionado={Boolean(selectedIds[titulo.idTitulo])}
            onSelecionar={() => onToggleId(titulo.idTitulo)}
          />
        ))}
        {titulos.length === 0 && (
          <TableRow>
            <TableCell colSpan={colunas.length + 2} align="center" sx={{ color: C.warmGrey, py: 3 }}>
              Nenhum título disponível para acordo.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

TableNovoAcordo.propTypes = {
  colunas: PropTypes.array.isRequired,
  titulos: PropTypes.array.isRequired,
  selectedIds: PropTypes.object.isRequired,
  onToggleId: PropTypes.func.isRequired,
  todosSelecionados: PropTypes.bool.isRequired,
  onToggleTodos: PropTypes.func.isRequired,
  ordenacao: PropTypes.shape({
    element: PropTypes.string,
    order: PropTypes.string,
  }).isRequired,
  onClickColuna: PropTypes.func.isRequired,
};
